import { type ReactNode } from "react"

import { BackgroundIcon, type BackgroundIconProps } from "../BackgroundIcon"
import { Icon } from "../Icon"
import { Text } from "../Text"
import styles from "./LinkCard.module.css"

type LinkCardProps = {
  href?: string
  target?: string
  children?: ReactNode
  onClick?: () => void
}

export function LinkCard(props: LinkCardProps) {
  const { href, target, children, onClick } = props

  if (!href) {
    return <div className={styles.linkCard}>{children}</div>
  }

  return (
    <a
      href={href}
      target={target}
      className={styles.linkCard}
      onClick={onClick}
    >
      {children}
    </a>
  )
}

type LinkCardIconProps = {
  name: BackgroundIconProps["name"]
}

export function LinkCardIcon(props: LinkCardIconProps) {
  const { name } = props

  return <BackgroundIcon name={name} size="large" color="purple" />
}

type LinkCardContentProps = {
  children?: ReactNode
}

export function LinkCardContent(props: LinkCardContentProps) {
  const { children } = props

  return <div className={styles.content}>{children}</div>
}

type LinkCardHeadingProps = {
  children?: ReactNode
}

export function LinkCardHeading(props: LinkCardHeadingProps) {
  const { children } = props

  return <Text variant="h4">{children}</Text>
}

type LinkCardDescriptionProps = {
  children?: ReactNode
}

export function LinkCardDescription(props: LinkCardDescriptionProps) {
  const { children } = props

  return <Text color="grey11">{children}</Text>
}

type LinkCardButtonProps = {
  children?: ReactNode
  footnote?: ReactNode
}

export function LinkCardButton(props: LinkCardButtonProps) {
  const { children, footnote } = props

  return (
    <div className={styles.button}>
      <div className={styles.buttonLabel}>
        <Text variant="bold" color="purple9">
          {children}
        </Text>
        <Icon name="arrowForward" color="purple9" size="medium" />
      </div>
      <div className={styles.buttonFootnote}>
        {footnote ? (
          <Text variant="small" color="grey11">
            {footnote}
          </Text>
        ) : null}
      </div>
    </div>
  )
}
